import {createApi} from '@reduxjs/toolkit/query/react';

import appConfig from '@/config/appConfig.typed';

import {getBaseQuery} from './apiUtils';

export const ICC_API_TAGS = {
    AUTO_DELIVERY_DCX: 'AutoDeliveryDcx',
} as const;

export const iccApi = createApi({
    reducerPath: 'iccApi',
    baseQuery: getBaseQuery(() => appConfig.getIccApiUrl()),
    tagTypes: Object.values(ICC_API_TAGS),
    endpoints: () => ({}),
});
